import { ReactNode } from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import themes from './theme/themes';

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ThemeProvider theme={createTheme(themes.light)}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default AppProvider;
